import create from 'zustand'
import { createUnityPlayerInstanceSlice } from './slices/unity-player-instance-slice'

// ! the 'createBuildingsSlice' slice might not be necessary; with the use of react-query might actually be enough
export const useBoundStore = create((...args) => ({
      // @ts-ignore
  ...createUnityPlayerInstanceSlice(...args),
}))
